const centerPanel = require('../../shop/views/center-panel.view.html').trim(),
    rightPanel = require('../../shop/views/right-panel.view.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.guestList', {
            url: '/suggestedlists?{pageNumber:int}&{sortBy}',
            resolve: {
                modules: [
                    '$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('lists');
                    },
                ],
            },
            onEnter: ['$state', 'ShopperService', ($state, shopperService) => {
                if (!shopperService.IsGuest) {
                    $state.go('shop.list');
                }
            }],
            views: {
                'left-panel@shop': {
                    controller: [
                        '$scope', 'SuggestedListService', 'ListProductService', 'BreakpointsService', '$state', function ($scope, suggestedListService, listProductService, breakpointsService, $state) {

                            suggestedListService.listSuggestedLists().then(() => {
                                $scope.suggestedLists = suggestedListService.suggestedlists;

                                if (!$state.params.Id) {
                                    // Navigate to first suggested list by default
                                    const firstSuggestedList = $scope.suggestedLists[0];
                                    const listId = firstSuggestedList.ID;
                                    const listName = firstSuggestedList.Name;
                                    suggestedListService.selectList(listProductService, listName, listId);

                                    $state.go('shop.guestList.suggestedlists', { Id: listId, name: undefined, cardId: undefined, productId: undefined, recipeId: undefined });
                                }
                            });
                        },
                    ],
                    template: require('../../lists/views/suggested-lists.html').trim(),
                },
            },
            data: {
                pageMetadata: {
                    title: 'Lists - Woolworths Online',
                    metaDescription: 'Lists - Woolworths Online',
                    metaRobot: 'noindex',
                },
            },
        })
        .state('shop.guestList.suggestedlists', {
            url: '/suggestedlists/{Id:int}',
            reloadOnSearch: false,
            resolve: {
                init: [
                    '$stateParams', 'SuggestedListService', function ($stateParams, suggestedListService) {
                        suggestedListService.listId = $stateParams.Id;
                    },
                ],
            },
            views: {
                'center-panel@shop': {
                    controller: [
                        '$state', function ($state) {
                            this.$state = $state;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-suggested-list-tile-list
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy">
                        </wow-suggested-list-tile-list>
                    `,
                },
            },
        })
        .state('shop.list', {
            url: '/mylists?{pageNumber:int}&{sortBy}',
            reloadOnSearch: false,
            resolve: {
                modules: [
                    '$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('lists');
                    },
                ],
            },
            onEnter: ['SavedListsService', (savedListsService) => {
                if (savedListsService.savedLists && savedListsService.savedLists.length > 0) {
                    savedListsService.listId = savedListsService.savedLists[0].ListId;
                }
            }],
            views: {
                'center-panel@shop': {
                    controller: [
                        '$state', 'SavedListsService', function ($state, savedListsService) {
                            this.$state = $state;
                            this.listid = savedListsService.listId;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-saved-list-tile-list
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy"
                            list-id="$ctrl.listid">
                        </wow-saved-list-tile-list>
                    `,
                },
                'left-panel@shop': {
                    template: require('../../lists/views/lists.html').trim(),
                },
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-wishlist-instrumentation></wow-rr-wishlist-instrumentation>',
                },
            },
            data: {
                authenticate: true,
                pageMetadata: {
                    title: 'Lists - Woolworths Online',
                    metaDescription: 'Lists - Woolworths Online',
                    metaRobot: 'noindex',
                },
            },
        })
        .state('shop.list.pastshops', {
            url: '/pastshops/{orderId}',
            reloadOnSearch: false,
            params: {
                totalRecordCount: null,
            },
            views: {
                'center-panel@shop': {
                    controller: [
                        '$state', function ($state) {
                            this.$state = $state;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-past-shop-tile-list
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy"
                            total-record-count="$ctrl.$state.params.totalRecordCount">
                        </wow-past-shop-tile-list>
                    `,
                },
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-mypage-instrumentation></wow-rr-mypage-instrumentation>',
                },
            },
        })
        .state('shop.list.pastordershops', {
            url: '/pastordershops/{orderId}',
            reloadOnSearch: false,
            resolve: {
                init: [
                    '$stateParams', 'PastShopService', 'ListProductService', function ($stateParams, pastShopService, listProductService) {
                        pastShopService.selectOrder(listProductService, $stateParams.orderId);
                    },
                ],
            },
            views: {
                'content@root': {
                    template: `${centerPanel} ${rightPanel}`,
                },
                'center-panel@shop.list.pastordershops': {
                    controller: [
                        '$state', function ($state) {
                            this.$state = $state;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-past-shop-tile-list
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy">
                        </wow-past-shop-tile-list>
                    `,
                },
            },
        })
        .state('shop.list.suggestedlists', {
            url: '/suggestedlists/{Id}',
            reloadOnSearch: false,
            resolve: {
                init: [
                    '$stateParams', 'SuggestedListService', function ($stateParams, suggestedListService) {
                        suggestedListService.listId = $stateParams.Id;
                    },
                ],
            },
            views: {
                'center-panel@shop': {
                    controller: [
                        '$state', function ($state) {
                            this.$state = $state;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-suggested-list-tile-list
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy">
                        </wow-suggested-list-tile-list>
                    `,
                },
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-generic-instrumentation></wow-rr-generic-instrumentation>',
                },
            },
        })
        .state('shop.list.edit', {
            url: '/{listId}',
            reloadOnSearch: false,
            params: {
                totalRecordCount: null,
            },
            resolve: {
                init: [
                    '$stateParams', 'SavedListsService', function ($stateParams, savedListService) {
                        savedListService.listId = $stateParams.listId;
                        savedListService.isListEmpty = false;
                        savedListService.freeTextProducts = false;
                        return savedListService.listSavedLists();
                    },
                ],
            },
            views: {
                'left-panel@shop': {
                    controller: ['$stateParams', function ($stateParams) {
                        this.listId = $stateParams.listId;
                    }],
                    controllerAs: 'editListController',
                    template: '<div class="my-lists-container navigation"><wow-saved-lists-edit list-id="editListController.listId"></wow-saved-lists-edit></div>',
                },
                'center-panel@shop': {
                    controller: [
                        '$state', function ($state) {
                            this.$state = $state;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-saved-list-tile-list
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy"
                            list-id="$ctrl.$state.params.listId"
                            total-record-count="$ctrl.$state.params.totalRecordCount">
                        </wow-saved-list-tile-list>
                    `,
                },
            },
            data: {
                isListEditMode: false,
            },
        })
        .state('shop.list.edit.freetext', {
            url: '/products?searchTerm',
            reloadOnSearch: false,
            resolve: {
                init: [
                    'SavedListsService', function (savedListService) {
                        savedListService.freeTextProducts = true;
                    },
                ],
            },
            views: {
                'center-panel@shop': {
                    controller: ['$state', function ($state) {
                        this.$state = $state;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-search-product-tile-list
                            search-term="$ctrl.$state.params.searchTerm"
                            is-special="false"
                            is-list="true"
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy">
                        </wow-search-product-tile-list>
                    `,
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/lists.js